import { shortenAddress, shortenEmail } from '@/utils';
import { Button, Grid, Image, Stack, Title } from '@mantine/core';
import { WalletIcon } from '@phosphor-icons/react';
import { PrivyProvider, usePrivy } from '@privy-io/react-auth';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

/**
 * Components
 */
import ComponentTheme from '@/components/theme';

const PageAuthPrivy: React.FC = () => {
    /**
     * Params
     */
    const [params] = useSearchParams();

    /**
     * Hooks
     */
    const navigate = useNavigate();

    const { authenticated, getAccessToken, login, logout, user } = usePrivy();

    const { t } = useTranslation();

    /**
     * Effects
     */
    useEffect(() => {
        if (params.get('redirect')) return;

        navigate('/');
    }, [params]);

    useEffect(() => {
        console.log('user :>> ', user);
    }, [user]);

    return (
        <Grid gap={0}>
            <Grid.Col span={6}>
                <Stack h="100dvh" justify="space-between" p="md">
                    <div></div>

                    <Stack gap={24} mx="auto" w={400}>
                        <Title mb={8} order={2}>
                            {t('loginOrSignup')}
                        </Title>

                        {authenticated ? (
                            <>
                                <Button
                                    fullWidth
                                    leftSection={<WalletIcon weight="bold" />}
                                    size="md"
                                    onClick={async () => {
                                        const url = new URL(params.get('redirect') as string);

                                        url.searchParams.set('token', (await getAccessToken()) as string);

                                        window.location.href = url.toString();
                                    }}
                                >
                                    {t('continueWith', {
                                        provider:
                                            shortenEmail(user?.email?.address) || shortenAddress(user?.wallet?.address),
                                    })}
                                </Button>

                                <Button color="red" size="md" variant="outline" onClick={logout}>
                                    {t('logout')}
                                </Button>
                            </>
                        ) : (
                            <Button fullWidth leftSection={<WalletIcon weight="bold" />} size="md" onClick={login}>
                                {t('loginWithPrivy')}
                            </Button>
                        )}
                    </Stack>

                    <ComponentTheme />
                </Stack>
            </Grid.Col>

            <Grid.Col span={6}>
                <Image h="100dvh" src="/auth/background.jpg" />
            </Grid.Col>
        </Grid>
    );
};

const PageAuthPrivyWrapper: React.FC = () => {
    return (
        <PrivyProvider
            appId="cmndcquje03fi0cl2xsb7vped"
            clientId="client-WY6XmE1SYnEdaSyAGvofKRC5tLdSrVvdi7bjeGomVAm2Y"
        >
            <PageAuthPrivy />
        </PrivyProvider>
    );
};

export default PageAuthPrivyWrapper;
